import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import config from '../config';

// READ-ONLY module (FNP-969): Reload is the only tool. No Add, no Edit, no
// Delete — a TestRun is a record of something that happened, written by the
// executor canary over @aws_iam. Do not add write affordances here.
const useTools = () => [<ReloadRecordsButton key='reload'/>];

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
